import card2 from './components/img/card2.jpg'


const list2 = [
    {
        id: 1,
        ID:'E-book',
        title: "E-Book My First Book of Pencil Control",
        author: "by Wonder House Books | 25 April 2018",
        price: 120.55,
        img: `${card2}`,
        progress:88,
        sold: 15,
        offer:'NEW',
        amount:1,
        link:'SingleCard1',
        SASA:'E-Books Product'
    },
    {
        id: 2,
        ID:'E-book',
        title: "E-Book My First Book of Pencil Control",
        author: "by Wonder House Books | 25 April 2018",
        price: 120.55,
        img: `${card2}`,
        progress:88,
        sold: 15,
        offer:'NEW',
        amount:1,
        link:'SingleCard1',
        SASA:'E-Books Product'
    },
    {
        id: 3,
        ID:'E-book',
        title: "E-Book My First Book of Pencil Control",
        author: "by Wonder House Books | 25 April 2018",
        price: 120.55,
        img: `${card2}`,
        progress:88,
        sold: 15,
        offer:'NEW',
        amount:1,
        link:'SingleCard1',
        SASA:'E-Books Product'
    },
    {
        id: 4,
        ID:'E-book',
        title: "E-Book My First Book of Pencil Control",
        author: "by Wonder House Books | 25 April 2018",
        price: 120.55,
        img: `${card2}`,
        progress:88,
        sold: 15,
        offer:'NEW',
        amount:1,
        link:'SingleCard1',
        SASA:'E-Books Product'
    },
];


export default list2